<div style="margin-top: 0px; margin-bottom: 30px;">
    <p class="main" [class.sub-section]="isSubSection">{{ header.main }}</p>
    <p class="sub">{{ header.sub }}</p>
</div>